import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../../../services/api';
import { cn } from '../../../utils/cn';
import { formatCurrency } from '../../../utils/currency';

let teamCache = null;

// Who sold it. Empty = the deal's or customer's owner (decided on save).
export function SalespersonSelect({ value, onChange, className }) {
  const [team, setTeam] = useState(teamCache || []);
  useEffect(() => {
    if (teamCache) return;
    api.get('/auth/team-members').then((r) => { teamCache = r.data.users || []; setTeam(teamCache); }).catch(() => {});
  }, []);
  if (!team.length) return null;
  return (
    <select aria-label="Salesperson" className={cn('w-full h-10 px-3 bg-[#F3F2F2] border border-[#D8DDE6] rounded text-[13px] outline-none', className)} value={value || ''} onChange={(e) => onChange(e.target.value || null)}>
      <option value="">Salesperson: deal or customer owner</option>
      {team.map((u) => <option key={u._id || u.id} value={u._id || u.id}>{[u.firstName, u.lastName].filter(Boolean).join(' ') || u.name || u.email}</option>)}
    </select>
  );
}

// Invoiced, collected, owed — on the CRM and sales dashboards. Finance roles
// see the company; everyone else sees invoices where they're the salesperson.
export function FinanceKpiStrip({ scope }) {
  const [k, setK] = useState(null);
  useEffect(() => {
    api.get('/crm/customer-finance/kpis', { params: scope ? { scope } : undefined }).then((r) => setK(r.data)).catch(() => setK(null));
  }, [scope]);
  if (!k) return null;
  const money = (v) => formatCurrency(v || 0, k.currency);
  const change = (now, before) => (before ? `${now >= before ? '+' : ''}${Math.round(((now - before) / before) * 100)}% vs last month` : 'Nothing last month');
  const cards = [
    ['Invoiced this month', money(k.invoicedThisMonth), change(k.invoicedThisMonth, k.invoicedLastMonth)],
    ['Collected this month', money(k.collectedThisMonth), change(k.collectedThisMonth, k.collectedLastMonth)],
    ['Outstanding', money(k.outstanding), k.overdueCount ? `${money(k.overdue)} overdue · ${k.overdueCount} invoice(s)` : 'Nothing overdue', k.overdue > 0],
    ['Won this month', money(k.wonThisMonth), `${money(k.weightedPipeline)} weighted pipeline`],
  ];
  return (
    <section className="flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <h2 className="text-[13px] font-bold text-[#2E2E2E]">{k.scope === 'company' ? 'Money in' : 'Your invoices'}</h2>
        <Link to="/dashboard/crm/finance-dashboard" className="text-[12px] text-[#0176D3] hover:underline">{k.scope === 'company' ? 'Finance dashboard' : ''}</Link>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        {cards.map(([label, value, hint, bad]) => (
          <div key={label} className="bg-white border border-[#E5E5E5] rounded-lg shadow-[0_1px_3px_rgba(0,0,0,0.08)] p-3 min-w-0">
            <div className="text-[10px] uppercase tracking-wide text-[#706E6B] font-semibold">{label}</div>
            <div className="text-[18px] font-semibold tabular-nums truncate">{value}</div>
            <div className={cn('text-[11px] truncate', bad ? 'text-[#BA0517]' : 'text-[#706E6B]')}>{hint}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
